<b3-modal [open]="true" overlay size="md" (b3-close)="close()">
  <b3-modal-header
    [heading]="title"
    aria-level="2"
    icon="error"
    icon-tone="danger"
    close-aria-label="Fechar"
    (b3-close)="close()">
  </b3-modal-header>

  <b3-modal-body>
    <p class="transference-error-modal__description">{{ description }}</p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="transference-error-modal__footer">
      <b3-button
        type="button"
        variant="outlined"
        tone="default"
        class="transference-error-modal__btn-support"
        (b3-click)="onSupport()">
        Suporte B3
      </b3-button>
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        class="transference-error-modal__btn-retry"
        (b3-click)="onRetry()">
        Tentar Novamente
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
